export const formatCamelCase = (str: string): string => {
  if (!str) return ''
  return (
    str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // insert space before capital letters
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2') // handle consecutive capitals
      .replace(/^./, char => char.toUpperCase()) ?? str // capitalize first letter
  )
}
